import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-usdt-cashin-form',
  templateUrl: './usdt-cashin-form.component.html',
  // Mantiene el layout del formulario en el grid declarado por el padre.
  styles: [':host { display: contents; }'],
})
export class UsdtCashinFormComponent {
  @Input() ctx!: any;
}
